// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = ./src/scss/main.scss
// module chunks = 7